/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  function initHeaderLogoScrollEffect() {
    document.addEventListener('DOMContentLoaded', function () {
      if (window.location.pathname !== '/' || window.innerWidth < 768) return;

      const logos = document.querySelectorAll('.header__logo, .header__desktop__logo-left');
      if (!logos.length) return;

      window.addEventListener('scroll', function () {
        logos.forEach(logo => {
          const isScrolled = window.scrollY > 10;

          if (isScrolled && !logo.classList.contains('scroll-down')) {
            logo.classList.add('scroll-down');
            setTimeout(() => logo.classList.add('animated'), 500);
          } else if (!isScrolled && logo.classList.contains('scroll-down')) {
            logo.classList.remove('scroll-down');
            logo.classList.remove('animated');
          }
        });
      });
    });
  }

  initHeaderLogoScrollEffect();

  setInterval(() => {
    document.querySelectorAll('.cart__widget--products').forEach(widget => {
      const productsContainer = widget.querySelector('.cart__widget__products');
      const title = widget.querySelector('.cart__widget__title');

      if (productsContainer && title) {
        if (productsContainer.children.length === 0) {
          title.style.display = 'none';
        } else {
          title.style.display = ''; // Reset to default if products exist
        }
      }
    });
  }, 100);

  if (document.querySelector('.show-more')) {
    document.querySelector('.show-more').addEventListener('click', function () {
      const items = document.querySelectorAll('.dropdown__family a');
      items.forEach(item => item.style.display = 'block'); // Vis alle links
      this.style.display = 'none'; // Skjul "Se mere"-knappen
    });
  }

  function interceptTreatmentAddToCarts() {
    const originalFetch = window.fetch;

    window.fetch = async function (input, init) {
      if (typeof input === 'string' && input.includes('/cart/add')) {
        try {
          const body = init?.body;
          if (body) {
            const formData = new URLSearchParams(body);
            const properties = Object.fromEntries(formData.entries());

            // Check for specific custom property
            if (properties['properties[Resource]'] != null) {
              // Modify the request, e.g. add a query param
              console.log('Intercepted cart/add request with properties:', properties);
              // Add "view_cart=true" to the URL of the website (not the request)
              const url = new URL(window.location.href);
              url.searchParams.set('view_cart', 'true');
              window.history.pushState({}, '', url.toString());
            }
          }
        } catch (e) {
          console.warn('Failed to intercept cart/add request:', e);
        }
      }

      return originalFetch(input, init);
    };
  }

  interceptTreatmentAddToCarts();

  // If page loads and has "view_cart=true" in the URL, open the cart drawer by submitting a event "theme:cart-drawer:open"
  if (window.location.search.includes('view_cart=true')) {
    const event = new CustomEvent('theme:cart:toggle');
    document.dispatchEvent(event);
  }
  
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
